import { LT_INCOMES_DATA_RECEIVED, LT_INCOME_UNLOADED, LT_INCOME_SAVED, LT_INCOME_DELETED } from './types'

export default function income(state = [], action = {}){
  switch (action.type) {
    case LT_INCOMES_DATA_RECEIVED:
    return action.data.sort(function(a, b) {
      let result = 0 
      let aAlloc = parseFloat(a.allocation)
      let bAlloc = parseFloat(b.allocation)
      aAlloc += (aAlloc > 0 && aAlloc < 1) ? 0 : 1
      bAlloc += (bAlloc > 0 && bAlloc < 1) ? 0 : 1
      result = (bAlloc - aAlloc) || (a.itemType.localeCompare(b.itemType)) || (a.description.localeCompare(b.description))
      return result
    })
    case LT_INCOME_UNLOADED:
      return []
    case LT_INCOME_SAVED:
      let isEdit = false
      const _state = state.map( v => {
        if(v.id === action.data.id){
          isEdit = true
          return action.data
        }else{
          return v
        }
      })
      if(!isEdit){
        return [action.data, ...state]
      }else{
        return _state
      }
    case LT_INCOME_DELETED:
      return state.filter( v => v.id !== action.data.id )
    default:
      return state;
  }
}
